import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from ".";
import { enumJoinedProgram, enumSubdomain } from "@configs";

interface IState {
  mobile: boolean;
  loading: boolean;
  drawer: boolean;
  domain: enumSubdomain;
  otpPhone: string;
  temp: string;
  program: enumJoinedProgram[]
}

const initialState: IState = {
  mobile: false,
  loading: false,
  drawer: false,
  domain: enumSubdomain.ADMIN,
  otpPhone: "",
  temp: "",
  program:[enumJoinedProgram.MNCH, enumJoinedProgram.SRHR, enumJoinedProgram.CDIC]
};

const appSlice = createSlice({
  name: "app",
  initialState: initialState,
  reducers: {
    setMobile: (state, action: PayloadAction<boolean>) => {
      state.mobile = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setDrawer: (state, action: PayloadAction<boolean>) => {
      state.drawer = action.payload;
    },
    updateDoamin: (state, action: PayloadAction<enumSubdomain>) => {
      state.domain = action.payload;
    },
    updatePhone: (state, action: PayloadAction<string>) => {
      state.otpPhone = action.payload;
    },
    updateTemp: (state, action: PayloadAction<string>) => {
      state.temp = action.payload;
    },
    updateProgram: (state, action: PayloadAction<enumJoinedProgram[]>) => {
      state.program = action.payload;
    }
  },
});

export const { setMobile, setLoading, setDrawer, updateDoamin, updatePhone, updateTemp, updateProgram } =
  appSlice.actions;

export const selectApp = (state: RootState) => state.app;

export default appSlice.reducer;
